module.exports = __webpack_public_path__ + "img/av319.ede328e6.png";